import { List } from 'immutable';
import { ANALYTICS_SCREEN_APP_LISTING, ANALYTICS_SCREEN_DISCOVER, ANALYTICS_SCREEN_MANAGE, ANALYTICS_SCREEN_MANAGE_APP, ANALYTICS_SCREEN_MANAGE_APP_REQUESTS, ANALYTICS_SCREEN_MANAGE_PROMOTIONS, ANALYTICS_SCREEN_SEARCH } from '../analytics/Sources';
import { makeRoute } from '../records/Route';
export const discoverRoute = makeRoute({
  analyticsSourceScreen: ANALYTICS_SCREEN_DISCOVER,
  path: '/discover'
});
export const discoverAppDetailsRoute = makeRoute({
  analyticsSourceScreen: ANALYTICS_SCREEN_APP_LISTING,
  path: '/discover/app/:appKey'
});
export const searchRoute = makeRoute({
  analyticsSourceScreen: ANALYTICS_SCREEN_SEARCH,
  path: '/discover/search'
});
export const manageRoute = makeRoute({
  analyticsSourceScreen: ANALYTICS_SCREEN_MANAGE,
  path: '/manage'
});
export const manageAppDetailsRoute = makeRoute({
  analyticsSourceScreen: ANALYTICS_SCREEN_MANAGE_APP,
  path: '/manage/app/:appKey'
});
export const manageAppRequestsRoute = makeRoute({
  analyticsSourceScreen: ANALYTICS_SCREEN_MANAGE_APP_REQUESTS,
  path: '/manage/app-requests'
});
export const managePromotionsRoute = makeRoute({
  analyticsSourceScreen: ANALYTICS_SCREEN_MANAGE_PROMOTIONS,
  path: '/manage/promotions'
});
export const allRoutes = List([discoverRoute, discoverAppDetailsRoute, searchRoute, manageRoute, manageAppDetailsRoute, manageAppRequestsRoute, managePromotionsRoute]);